export const faqs = [
  {
    id: 1,
    question: '白云视频是否需要注册才能观看？',
    answer: '不需要！白云视频所有内容免费在线观看，无需注册登录，打开即看，方便快捷。我们致力于为用户提供无门槛的高清影视体验。',
  },
  {
    id: 2,
    question: '白云视频支持哪些设备观看？',
    answer: '白云视频全面支持PC端、平板、手机等多种设备在线观看，采用自适应播放技术，根据您的网络环境自动匹配最清晰度，保障流畅观影体验。',
  },
  {
    id: 3,
    question: '视频加载缓慢或卡顿怎么办？',
    answer: '建议您检查网络连接状况，或尝试切换清晰度。白云视频采用先进的CDN加速技术，多节点覆盖全国，通常能保证流畅播放。如果问题持续，可尝试刷新页面或更换浏览器。',
  },
  {
    id: 4,
    question: '白云视频和97视频、丝瓜视频是什么关系？',
    answer: '白云视频是一个独立的影视聚合平台，与97视频、丝瓜视频、蓝莓视频等平台属于同类型服务，我们都致力于为用户提供丰富的高清影视资源。白云视频在资源丰富度与播放体验上独具优势。',
  },
  {
    id: 5,
    question: '白云视频的资源多久更新一次？',
    answer: '白云视频内容团队每日更新，最新热播电影电视剧同步上线。热门综艺节目播出后24小时内更新，确保您不错过任何精彩内容。',
  },
  {
    id: 6,
    question: '是否可以下载视频离线观看？',
    answer: '目前白云视频支持在线流畅播放，暂不提供下载功能。我们正在开发离线缓存功能，敬请期待。建议您在WiFi环境下观看以获得最佳体验。',
  },
  {
    id: 7,
    question: '白云视频是否收取费用？',
    answer: '白云视频所有内容永久免费，无任何隐藏收费项目。我们通过广告收入维持运营，请放心使用。',
  },
  {
    id: 8,
    question: '如何反馈问题或建议？',
    answer: '您可以通过「关于我们」页面的联系方式与我们取得联系，或发送邮件至官方邮箱。我们重视每一位用户的反馈，将尽快为您处理。',
  },
];